import React from 'react';
import { Card, CardContent, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AvailablePropertyFragmentExtra } from '../../AvailableProperties/AvailableProperties';
import PropertyCard from './PropertyCard';

const useStyles = makeStyles(() => ({
    container: {
        height: 'calc(100vh - 1rem)',
        overflow: 'auto',
        borderRadius: 0,
        boxShadow: 'none',
        background: 'none'
    },
}));

type PropertiesProps = {
    properties: AvailablePropertyFragmentExtra;
}

export const Properties = ({
    properties,
}: PropertiesProps) => {
    const classes = useStyles();

    return (
        <Card className={classes.container}>
            <CardContent>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={4} lg={4} key={properties.id}>
                        <PropertyCard
                            property={properties}

                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};
